import { Injectable, Inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DwSystemConfigService } from '../../config/config.service';
import { DwHttpRequestUrlService } from '../service/http-request-url.service';


/**
 * Http API 攔截器
 *
 * @export
 */
@Injectable()
export class DwHttpApiInterceptor implements HttpInterceptor {
  isExternalURL:boolean;
  isNoSchemeURL:boolean
  isPathAbsolute:boolean;
  apiUrl: string;
  constructor(
    private configService: DwSystemConfigService,
    private dwHttpRequestUrlService:DwHttpRequestUrlService
  ) {
    this.configService.get('apiUrl').subscribe(
      url => {
        this.apiUrl = url;
        //规定apiUrl后端配置URL为http://或https://开头，代表带子路径的开发环境或为外部URL
        this.isExternalURL = (url.startsWith('http://') || url.startsWith('https://'));
        //不带协议的绝对URL
        this.isNoSchemeURL = (url.startsWith('//'));
        //后端采用绝对路径配置方式配置 begins with "/" but not "//" 规定表示apiUrl后端配置URL为相对路径例如: /restful/service/
        this.isPathAbsolute=(url.startsWith('/')&&!(url.startsWith('//')));
      });
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {





    const url = req.url;

     /* David Li 30Aug2023 分销URL(https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
     * 1. Absolute URI: 场景为ExternalURL: http://、https://、double slash ("//") 
     * 2. relative-reference: path-abempty、path-absolute  
     */

    //绝对URL
    const isAbsoluteURL:boolean = (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//'));


     //相对URL之path-absolute: begins with "/" but not "//"
    const isRelativeURL = (url.startsWith('/')&&!(url.startsWith('//')));


    //资源文件从前端加载
    const isAssets:boolean= url.startsWith('assets/');

  
    //非绝对URL
    if (!isAbsoluteURL) {
    //相对URL
      //非资源文件
      if(!isAssets) {
      //相对URL

        //带子路径的开发环境
        if(this.isExternalURL){ 

          //后端配置URL+相对URL
          req = req.clone({
            url: this.apiUrl + url
          });

          // //从baseURI截取URL+相对URL
          // let baseURI:string =  document.baseURI;

          // if(baseURI.charAt(baseURI.length-1) === "/") {
          //   baseURI = baseURI.slice(0, -1);
          // }

          // //path-absolute
          // if(isRelativeURL){
          //   req = req.clone({
          //     url: baseURI + url
          //   });
          //  }else{
          //  //非path-absolute 
          //   req = req.clone({
          //     url: baseURI +'/'+ url
          //   });  
          //  }
        }else{
        //非资源文件&&不带子路径的相对URL&&typeof　this.apiUrl === 'undefined'

          //不带协议的绝对URL
          if(this.isNoSchemeURL){
            //后端配置URL+相对URL
            req = req.clone({
              url: this.apiUrl + url
            });
          }else{

              //后端采用相对路径配置方式配置
              if(this.isPathAbsolute){
                //非相对URL之path-absolute: begins with "/" but not "//"&&非资源文件
                if(!isRelativeURL){
                  //从baseURI截取URL+相对URL
                  let baseURI:string =  document.baseURI;

                  if(baseURI.charAt(baseURI.length-1) === "/") {
                    baseURI = baseURI.slice(0, -1);
                  }

                  req = req.clone({
                    url: baseURI+this.apiUrl + url
                  });
                }else{
                  //相对URL之path-absolute: begins with "/" but not "//"&&非资源文件
                  let baseURI:string =  document.baseURI;

                  if(baseURI.charAt(baseURI.length-1) === "/") {
                    baseURI = baseURI.slice(0, -1);
                  }

                  req = req.clone({
                    url: baseURI + url
                  });

                }
              }else{

                req = req.clone({
                  url: this.apiUrl + url
                });

              }
          }
        }

      }else{
      //资源文件
         
        //从baseURI+相对URL
        let baseURI:string =  document.baseURI;

        req = req.clone({
          url: baseURI + url
        });

      }

    }else{
    //绝对URL
    
      req = req.clone({
        url: url
      });

    }
    
    return next.handle(req).pipe(
      map(
        (event: any) => {
         
          // 攔截響應：轉換成API的格式
          if (event instanceof HttpResponse) {
                const resp: HttpResponse<any> = event;
                event = event.clone({ body: isAbsoluteURL ? resp.body : resp.body.response });
                return event;
          }
        }
      ),catchError((error: any) => {  
        // 捕获并处理错误响应  
        if (error instanceof HttpErrorResponse) {  
          // 这里可以处理特定的HTTP状态码错误  
          switch (error.status) {  
            case 401:  
              if(!this.dwHttpRequestUrlService.has401ErrorBeenShown()) {
              // 未授权，可以重定向到登录页或显示错误消息
              this.dwHttpRequestUrlService.show401Error();
                console.log("未授权，可以重定向到登录页或显示错误消息");
              }
              break;  
            case 403:  
              if(!this.dwHttpRequestUrlService.has403ErrorBeenShown()) {


                if(error.error !== undefined){

                  this.dwHttpRequestUrlService.show403Error(error.error.std_data.Quantity);
                }
                console.log("禁止访问");
                // 禁止访问，可以显示错误消息  
              }
              break;  
            case 404:  
              console.log("未找到资源，可以显示友好的错误页面");
              // 未找到资源，可以显示友好的错误页面  
              break;  

            case 302:
              console.log("跳转到Licnese失败");
            // ... 处理其他状态码  
            default:  
              console.error('这是什么报错', error);
              // 对于其他错误，可以选择重新抛出错误或返回一个新的Observable  
              console.error('An unexpected error occurred:', error);  
          }  
          // 可以选择返回一个Observable.throwError()来继续错误处理链  
          // 或者返回一个Observable.of()来模拟一个成功的响应（不推荐，除非你有特殊需求）  
          return throwError(error); // 重新抛出错误，让上层调用者可以处理它  
        }  
        // 如果错误不是HttpErrorResponse类型，则直接重新抛出  
        return throwError(error);  
      })  
    );
  }
}
